import React from "react";
import Loader from "./Loader";

export const ButtonLoader = () => {
  return <Loader style={{ height: 24, width: "auto", margin: "0 auto" }} />;
};
